// removed by extract-text-webpack-plugin
module.exports = {"loader":"loader_276av","load":"load_lFiac"};


//////////////////
// WEBPACK FOOTER
// ./app/components/loader/styles.scss
// module id = 441
// module chunks = 1